import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[piqetAngularInputNumberValidation]',
})
export class InputNumberValidationDirective {
  constructor(private readonly el: ElementRef, private readonly control: NgControl) {}

  @HostListener('input', ['$event'])
  onInputChange(event: InputEvent) {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // Remove any non-digit characters except decimal point
    value = value.replace(/[^0-9.]/g, '');

    // Ensure only one decimal point
    const parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts.slice(1).join('');
    }

    // Prevent negative values
    value = value.replace(/-/g, '');

    // Update input value
    input.value = value;

    // Update form control value
    if (this.control) {
      this.control.control?.setValue(value === '' ? null : parseFloat(value));
    }
  }

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    const pattern = /[0-9.]/;
    const inputChar = String.fromCharCode(event.charCode);

    // Allow only numbers and decimal point
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }

    // Prevent multiple decimal points
    if (inputChar === '.' && (event.target as HTMLInputElement).value.includes('.')) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    if (event.clipboardData) {
      const pastedInput = event.clipboardData.getData('text/plain');
      const numericValue = pastedInput.replace(/[^0-9.]/g, '');

      if (this.control) {
        this.control.control?.setValue(numericValue === '' ? null : parseFloat(numericValue));
      }
    }
  }
}
